import {useIntl} from 'react-intl'
import {techSpecMessages} from '../components/editorial-components/accordion/constant'
import {useGetContentByTitle} from '../custom-api/hooks/use-get-content-by-title'

export const useArrayOfSpecifications = (products) => {
    const {formatMessage} = useIntl()
    const {data} = useGetContentByTitle('Tech specs labels')

    const arrayOfSpecifications = []
    products?.forEach((product) => {
        const specifications = Object.entries(product?.c_groupedTechSpecs || {})
            .map(([category, values]) => {
                if (!Array.isArray(values) || values.length === 0) return null

                const processedValues = values
                    .filter((key) => typeof key === 'string' && product?.[`c_${key}`])
                    .map((key) => {
                        const prefixedKey = `c_${key}`
                        const value = product[prefixedKey]
                        const prefixedLabelKey = `tech_spec_${key}`

                        return {
                            value_name: data?.[prefixedLabelKey]?.defaultMessage || key,
                            value: String(value),
                            has_check: value === true || value === 'true',
                        }
                    })

                if (processedValues.length === 0) return null

                return {
                    accordion_title:
                        data?.[`tech_spec_${category}`]?.defaultMessage ||
                        (techSpecMessages?.[category]
                            ? formatMessage(techSpecMessages[category])
                            : category),
                    values: processedValues,
                }
            })
            .filter(Boolean)

        arrayOfSpecifications.push(specifications)
    })
    return arrayOfSpecifications
}

const useSpecifications = (product) => {
    const {formatMessage} = useIntl()
    const {data} = useGetContentByTitle('Tech specs labels')

    const accordionData = Object.entries(product?.c_groupedTechSpecs || {})
        .map(([category, values]) => {
            if (!Array.isArray(values) || values.length === 0) return null

            const processedValues = values
                .filter((key) => typeof key === 'string' && product?.[`c_${key}`])
                .map((key) => {
                    const prefixedKey = `c_${key}`
                    const value = product[prefixedKey]
                    const prefixedLabelKey = `tech_spec_${key}`

                    return {
                        value_name: data?.[prefixedLabelKey]?.defaultMessage || key,
                        value: String(value),
                        has_check: value === true || value === 'true',
                    }
                })

            if (processedValues.length === 0) return null

            return {
                accordion_title:
                    data?.[`tech_spec_${category}`]?.defaultMessage ||
                    (techSpecMessages?.[category]
                        ? formatMessage(techSpecMessages[category])
                        : category),
                values: processedValues,
            }
        })
        .filter(Boolean)

    return accordionData
}

export default useSpecifications
